"use strict";

/**
* Реквизит карточки типа «Признак».
* 
* @class WebAccess.components.wrappers.form.requisites.Pick
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {object} data Данные для инициализации реквизита
*/
(function (global) {

  var Pick = global.WA.CMP.wrappers.form.requisites.BaseRequisite.extend({
    className: "Pick",


    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.Pick#_showSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.Pick
    */
    _showSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var isCheckbox = me._isCheckBox(jControl);
        var jContainer = jControl.parent();
        jContainer.find('.Req_Icon').hide();
        jContainer.append('<div class="circle-spinner pick-input__spinner' + (isCheckbox ? ' pick-input__spinner_checkbox' : '') + '"></div>');
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.Pick#_hideSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.Pick
    */
    _hideSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var jContainer = jControl.parent();
        jContainer.find('.Req_Icon').show();
        jContainer.find('.circle-spinner').remove();
      }
      return me;
    },
    //---------------------------------------------------------------------//

    _isCheckBox: function (jControl) {
      return jControl.length && !jControl.is('.pickField');
    },

    _getControls: function () {
      var me = this;
      var res = [];

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];
      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];
        var jControl = $('input#' + id + 'inp, input#' + id);
        if (jControl.length == 0) {
          jControl = $('#' + id + '_value');
          if (jControl.length == 0) {
            jControl = $('#' + id);
          }
        }
        res.push(jControl);
      };
      return res;
    },

    /**
    * Получить значение в поле по его имени.
    *
    * @since 5.0.0.7100
    * @method WebAccess.components.wrappers.form.requisites.Pick#_getControlValue
    * @private
    */
    _getControlValue: function (controlName) {
      var me = this;
      var jControl;
      jControl = $("input#" + controlName.replace('inp', '').replace('_display', '') + '_value');
      if (jControl.length == 0) {
        jControl = $("select#" + controlName.replace('inp', '').replace('_display', ''));
        if (!me._isCheckBox(jControl)) {
          jControl = $("input#hidd" + controlName.replace('inp', ''));
        }
      }
      return (!jControl.val()) ? null : jControl.val();
    },
    //---------------------------------------------------------------------//

    /**   
    * Получить отображаемое значение реквизита.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#getDisplayValue
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {
      if (this._data.isRendered === false) return this._data.displayValue;
      if (this.controls.length === 0) return;
      var jC = opt_jControl || this.controls[0];
      return jC.val();
    },
    //---------------------------------------------------------------------//

    _isEditable: function (jControl) {
      return jControl.hasClass('editable');
    },
    //---------------------------------------------------------------------//

    /**   
    * Установить значение реквизита.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#setValue
    * @param value {string} Устанавливаемое значение реквизита
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызов триггера события типа change
    * @return { WebAccess.components.wrappers.form.requisites.Pick} Текущий объект реквизита – Pick.
    * @since 5.0.0.7100
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      var me = this;
      if (_.isUndefined(value)) return this;
      opt_needTriggerResult = (opt_needTriggerResult !== false);

      if (me.controls.length === 0) return me._setInvisibleValues(value, opt_displayValue, opt_needTriggerResult);

      var jControl;
      for (var i = 0; i < this.controls.length; i++) {
        jControl = this.controls[i];
        if (me._isCheckBox(jControl)) {
          jControl.val(value);

          var jDisplay = me._getCheckBoxControl(jControl);
          
          if ((typeof jControl.parents('span').data('requisite') !== 'undefined') && (value == jControl.parents('span').data('requisite').yes)) jDisplay.attr('checked', 'checked').prop('checked', true);
          else jDisplay.removeAttr('checked').prop('checked', false);
          me._isChanged = true;
        }
      };

      var setValue = function (control, value, opt_displayValue, opt_needTriggerResult) {
        var ddInstance = control.data('DropDownListInstance');
        if (ddInstance) {
          ddInstance.setValue(value, opt_displayValue, opt_needTriggerResult);
        };
      };

      _(me.controls).each(function (jControl) {
        if (!me._isCheckBox(jControl)) {
          if (jControl.data('DropDownListInstance')) {
            setValue(jControl, value, opt_displayValue, opt_needTriggerResult);
          } else {
            jControl.bind('Init', function () {
              setValue(jControl, value, opt_displayValue, opt_needTriggerResult);
            });
          }
          if (opt_displayValue) {
            jControl.attr("title", opt_displayValue);
          } else {
            jControl.removeAttr('title');
          }
          me._isChanged = true;
        };
      });

      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * При смене значения в одном контроле оно должно примениться ко всем.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindMirrors
    * @private
    * @since 5.0.0.7100
    */
    _bindMirrors: function () {
      var me = this;
      if (me.controls.length > 1) {
        me.bind('change', function (context, ev, data) {
          me.setValue(data.value, undefined, false);
        });
      }
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить контрол для чек-бокса.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#_getCheckBoxControl
    * @return {object} - чек-бокс для текущего контрола.
    * @private 
    * @since 5.5.0.1310
    */
    _getCheckBoxControl: function (jControl) {
      var cardFormControl = jControl.closest('span');
      return cardFormControl.find('input[type=checkbox]');
    },
    //---------------------------------------------------------------------//

    /**
    * Отключение контрола реквизита.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#_disableControl
    * @return { WebAccess.components.wrappers.form.requisites.Pick}
    * @private 
    * @since 5.0.0.7100
    */
    _disableControl: function (jControl) {
      var me = this;
      jControl.addClass("Req_Disabled").attr('tabindex', -1);
      jControl.next('.Req_Icon').addClass('PickReq_Icon_Disabled');
      if (me._isEditable(jControl)) {
        jControl.prop('readonly', true);
      }
      if (me._isCheckBox(jControl)) {
        var jDisplay = me._getCheckBoxControl(jControl);
        if (jDisplay.length > 0) {
          jDisplay.attr('disabled', true); 
        }
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Включение контрола реквизита.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#_enableControl
    * @private
    * @return { WebAccess.components.wrappers.form.requisites.Pick}
    * @since 5.0.0.7100
    */
    _enableControl: function (jControl) {
      var me = this;
      jControl.removeClass("Req_Disabled").removeAttr('tabindex');
      jControl.next('.Req_Icon').removeClass('PickReq_Icon_Disabled');
      if (me._isEditable(jControl)) {
        jControl.prop('readonly', false);
      }
      if (me._isCheckBox(jControl)) {
        var jDisplay = me._getCheckBoxControl(jControl);
        if (jDisplay.length > 0) {
          jDisplay.attr('disabled', false);
        }
      }
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * @private
    */
    _bindEvents: function () {
      var me = this;

      if (me.controls.length === 0) {
        var controlInit = $.Deferred();
        me._allControlsInit.push(controlInit);
        controlInit.resolve();
        return me;
      }

      _(me.controls).each(function (jControl) {
        var controlInit = $.Deferred();
        me._allControlsInit.push(controlInit);

        if (me._isCheckBox(jControl)) {
          jControl = me._getCheckBoxControl(jControl);
          me._bindControlEvents(jControl, true);
          controlInit.resolve();
          return;
        };

        if (jControl.data('DropDownListInstance')) {
          me._bindControlEvents(jControl);
          controlInit.resolve();
        } else {
          jControl.bind('Init', function () {
            me._bindControlEvents(jControl);
            controlInit.resolve();
          });
        }
      });

      return me;
    },
    //---------------------------------------------------------------------//

    /**
   * @private 
   * @method WebAccess.components.wrappers.form.requisites.Pick#_bindControlEvents
   * @since 5.0.0.7100
   */
    _bindControlEvents: function (jControl, isCheckBox) {
      var me = this;
      var reqFullName = me.fullName;
      var eventName = 'change.BaseRequisite';
      if (isCheckBox && (WA.ENV.browser.name === 'IE')) {
        eventName = 'click.BaseRequisite';
      }

      jControl.off(eventName).on(eventName, function (ev) {
        var value = me.getValue($(this));
        var displayValue = me.getDisplayValue($(this));
        me._fireChange(reqFullName, value, displayValue, ev);
      });
    },
    //---------------------------------------------------------------------//

    /**
    * @private
    */
    _applyControlMethod: function (jControl, method, args) {
      var me = this;
      var instance = jControl.data('DropDownListInstance');
      if (instance) {
        instance[method].apply(instance, args);
      } else {
        jControl.bind('Init', function () {
          instance = jControl.data('DropDownListInstance');
          instance[method].apply(instance, args);
        });
      }
    },
    //---------------------------------------------------------------------//

    /**
    * Очистка списка доступных для выбора значений.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#clearValues
    * @return { WebAccess.components.wrappers.form.requisites.Pick}
    * @since 5.2.0.2014
    */
    clearValues: function () {
      var me = this;
      _(me.controls).each(function (jControl) {
        if (me._isCheckBox(jControl)) {
          jControl.parents('span').data('requisite', {});
        } else {
          me._applyControlMethod(jControl, 'clearDropDownListItems');
        }
      });
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Добавление нового значения в список доступных для выбора.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#addValue
    * @param  {string} value значение (например "Y", "Д", "Н")
    * @param  {string} displayValue отображаемое значение (например "Да")
    * @param  {boolean} [opt_isDisabled] значение недоступно для выбора
    * @return { WebAccess.components.wrappers.form.requisites.Pick}
    * @since 5.2.0.2014
    */
    addValue: function (value, displayValue, opt_isDisabled) {
      var me = this;
      var item = [value, displayValue, displayValue.escapeHtml(), opt_isDisabled];
      _(me.controls).each(function (jControl) {
        if (me._isCheckBox(jControl)) {
          if (!jControl.parents('span').data('requisite')['yes']) {
            jControl.parents('span').data('requisite')['yes'] = value;
          } else {
            jControl.parents('span').data('requisite')['no'] = value;
          }
        } else {
          me._applyControlMethod(jControl, 'addDropDownListItem', [item]);
        }
      });
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Удаление значения из списка доступных для выбора.
    *
    * @method  WebAccess.components.wrappers.form.requisites.Pick#removeValue
    * @param  {string} value значение (например "Y", "Д", "Н")
    * @return { WebAccess.components.wrappers.form.requisites.Pick}
    * @since 5.2.0.2014
    */
    removeValue: function (value) {
      _(me.controls).each(function (jControl) {
        me._applyControlMethod(jControl, 'removeDropDownListItem', [value]);
      });
      return me;
    }
    //---------------------------------------------------------------------//
  });

  global.WA.CMP.wrappers.form.requisites.Pick = Pick;
})(window);


